/* eslint-disable */
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import { alpha, useTheme } from '@mui/material/styles';

import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiUrl, postRequest } from '../utils/services';
import { useRouter } from '../routes/hooks';
import { AuthContext } from '../context/AuthContext';
import Logo from '../components/logo';
import { bgGradient } from '../theme/css';

export default function ForgotPasswordPage() {

    const theme = useTheme();
    const navigate = useNavigate();
    const router = useRouter();

    const [buttonLoad, setButtonLoad] = useState(false);

    // const { loginUser, forgotPasswordInfo, loginError, isLoginLoading, updateForgotPasswordInfo } = useContext(AuthContext);
    const {  forgotPasswordInfo, setToats, updateForgotPasswordInfo } = useContext(AuthContext);

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setButtonLoad(true);
        
        if (!forgotPasswordInfo.email) {
            setToats({
                message: 'Email field is required!',
                open: true,
                type: 'error'
              })
            return;
        }

        const response = await postRequest(`${apiUrl}/users/forgotPassword`, JSON.stringify(forgotPasswordInfo));

        if (response.error) {
            console.error('Error:', response.error);
            setToats({
                message: response?.message?.error ?? response?.message,
                open: true,
                type: 'error'
              })
            // return;
        } else {
            setToats({
                message: response?.message,
                open: true,
                type: 'success'
              })
            // navigate('/chat/login');
        }

        setButtonLoad(false);

    }

    const renderForm = (
        <>
            <form action="" onSubmit={handleForgotPassword}>
                <Stack spacing={3}>
                    <TextField name="email" label="Email address" onChange={((e) => updateForgotPasswordInfo({ ...forgotPasswordInfo, email: e.target.value }))} />

                    {/* <TextField
                    name="newPassword"
                    label="New Password"
                    onChange={((e) => updateForgotPasswordInfo({ ...forgotPasswordInfo, newPassword: e.target.value }))}
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                /> */}
                </Stack>

                <Stack direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 3 }}>
                    <Link variant="subtitle2" href="/admin/login" underline="hover">
                        Login?
                    </Link>
                </Stack>

                <LoadingButton
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    color="inherit"
                    onClick={handleForgotPassword}
                    loading={buttonLoad}
                >
                    Submit
                </LoadingButton>
            </form>
        </>
    );

    return (
        <>
            <Box
                sx={{
                    ...bgGradient({
                        color: alpha(theme.palette.background.default, 0.9),
                        imgUrl: '/assets/background/overlay_4.jpg',
                    }),
                    height: 1,
                }}
            >
                <Logo
                    sx={{
                        position: 'fixed',
                        top: { xs: 16, md: 24 },
                        left: { xs: 16, md: 24 },
                    }}
                />

                <Stack alignItems="center" justifyContent="center" sx={{ height: 1 }}  p={2}>
                    <Card
                        sx={{
                            p: 5,
                            width: 1,
                            maxWidth: 420,
                        }}
                    >
                        <Typography variant="h4" sx={{mb:4}}>Forgot Password</Typography>

                        {/* <Typography variant="body2" sx={{ mt: 2, mb: 5 }}>
                            Don’t have an account?
                            <Link href="/chat/register" variant="subtitle2" sx={{ ml: 0.5 }}>
                                Get started
                            </Link>
                        </Typography> */}
                        {renderForm}
                    </Card>
                </Stack>
            </Box>
        </>
    )
}

